<!--
 * @Description: 上传附件
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-06-25 13:42:08
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2025-12-26 16:05:00
-->
<template>
  <div
    :class="[
      'cloud-page-com',
      'cloud-content',
      showBorder ? 'cloud-com-border' : '',
      props?.disabled ? 'cloud-com-disabled' : 'cloud-com-normal',

      // 激活状态样式：蓝色实线边框（优先级高于拖拽）
      showBorder ? (isActive && !props?.disabled ? 'click-active-border' : '') : ''
    ]"
    @paste="handlePaste($event)"
    @dragover="handleDragOver($event)"
    @drop="handleDrop($event)"
    @dragenter="handleDragEnter($event)"
    @dragleave="handleDragLeave($event)"
    @click="handleClick"
    :ref="($event) => setRef($event)"
  >
    <div class="cloud-item-list">
      <div class="cloud-item-list-content">
        <template v-if="setFileList?.length > 0">
          <draggable :class="['cloud-draggable-content', `cloud-draggable-content-${instanceId}`]" :disabled="props?.disabled" animation="300" :group="{ name: 'group', sort: true, pull: true }" :list="setFileList" :move="onGroupMove" @end="onGroupEnd">
            <template #item="{ element: fileItem, index }">
              <div :key="index" class="cloud-item-list-item">
                <fh-attachment-preview :file-item="fileItem" :show-video-cover="false" :icon-style="data.iconStyle" :key="index" :index="index" :list="setFileList" />

                <div class="preview-content" v-if="fileItem?.signedUrl || fileItem?.response?.data?.[0]?.url || fileItem?.url">
                  <jw-tooltip :content="$t('预览')">
                    <jw-link :href="setLink(fileItem)" :target="setTarget(fileItem)" @click="openPreview(fileItem, index)" class="preview-link">
                      <qfei-icon-view-outlined />
                    </jw-link>
                  </jw-tooltip>
                  <jw-tooltip :content="$t('删除')">
                    <span class="preview-link delete-link">
                      <qfei-icon-close-one-outlined @click="beforeRemove(fileItem)" v-if="showRemoveBtn" />
                    </span>
                  </jw-tooltip>
                  <jw-tooltip :content="$t('下载')">
                    <span class="preview-link">
                      <qfei-icon-download-outlined @click="handleDownload(fileItem)" />
                    </span>
                  </jw-tooltip>
                </div>
                <template v-if="fileItem?.status">
                  <div class="progress-con" v-if="fileItem?.status != 'done'">
                    <template v-if="fileItem?.status == 'uploading'">
                      <div class="loading-circle"></div>
                    </template>
                    <template v-if="fileItem?.status == 'error'">
                      <jw-tooltip :content="$t('删除')">
                        <qfei-icon-close-one-outlined @click="beforeRemove(fileItem)" class="delete-file-icon" />
                      </jw-tooltip>
                      <jw-tooltip :content="$t('重试')">
                        <qfei-icon-reset-upload-outlined @click="retryUpload(fileItem)" class="retry-file-icon" />
                      </jw-tooltip>
                    </template>
                  </div>
                </template>
              </div>
            </template>
          </draggable>
        </template>
      </div>
      <input type="text" ref="inputActiveRef" v-if="!props?.showBorder && !props?.disabled" class="cloud-input-active" />
      <jw-upload :show-upload-button="setFileList?.length ? false : true" list-type="picture" :image-preview="true" :limit="limit" :disabled="true" :accept="accepts" :custom-request="customUpload" name="file" multiple :headers="data.headers" ref="uploadRef" @change="uploadChange" :show-file-list="false" @before-upload="beforeUpload" @exceed-limit="exceedLimit" :show-remove-button="false" draggable>
        <template #upload-button>
          <div class="upload-button-container">
            <div class="upload-button-content">
              <p class="upload-button-text">{{ $t('粘贴或拖拽至这里上传') }}</p>
              <p class="upload-button-tips">{{ getTips }}</p>
            </div>
          </div>
        </template>
      </jw-upload>
      <div :class="['attach-editor-upload', !props?.disabled ? 'attach-editor-upload-normal' : '']">
        <input type="file" :accept="'*'" name="upload" class="attache-upload" multiple ref="fileInput" @change="onFileChange" :disabled="getDisabled" />
        <div :class="['upload-button-add', props?.btnBorder ? 'upload-button-border' : '']" @click="selectFiles">
          <qfei-icon-add-two-outlined class="font-size-12" /><span class="upload-button-add-text">{{ $t('添加本地文件') }}</span>
        </div>
      </div>
      <!-- 拖拽过程样式 -->
      <div class="attach-editor-cover" v-if="showCover && !props?.disabled">
        <div class="attach-editor-drag">
          <div :class="['attach-editor-drag-content', showDrag ? (isHovered ? 'cover-hover-active' : 'cover-hover-default') : isHovered ? 'cover-hover-active-bg' : '']">
            <qfei-icon-reset-upload-outlined class="upload-button-icon" />
            <p class="upload-button-text">{{ $t('粘贴或拖拽上传') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <template v-if="visible">
    <fh-preview-modal ref="previewModalRef" :index="getFileIndex" :list="setFileList" :active-file="getFileItem" />
  </template>
</template>
<script setup>
import { reactive, ref, computed, onMounted, onUnmounted, nextTick } from 'vue';
import draggable from 'vuedraggable';
import { Message } from '@arco-design/web-vue';
import { getToken } from '@/utils/auth';
import { tools } from '@/utils/tools';
import useXlUpload from '@/hooks/upload';
import { QfeiIconAddTwoOutlined, QfeiIconResetUploadOutlined, QfeiIconViewOutlined, QfeiIconCloseOneOutlined, QfeiIconDownloadOutlined } from '@qfei-design/icons-vue';
const { setUrl, checkInvalidUrl, customRequest, getOssConfig, getFileSuffix, accepts, filePath, createFileItem, getDraggedFiles, getFileType, downloadFile, setOssConfig, getSignedUrl } = useXlUpload();
import { cloneDeep } from 'lodash';
import { useUploadStore, useGrayscaleStore } from '@/store';
const uploadStore = useUploadStore();
const { grayList } = useGrayscaleStore();
const previewModalRef = ref(null);
const emits = defineEmits(['cb', 'onActivate']);
const fileInput = ref(null);
const props = defineProps({
  defaultFileList: {
    //默认的上传文件
    type: Array
  },
  disabled: {
    //是否禁用
    type: Boolean,
    default: false
  },
  showRemoveBtn: {
    //是否显示删除按钮
    type: Boolean,
    default: true
  },

  fieldExt: {
    //配置信息
    type: [Object, String],
    default: () => {}
  },
  showUploadButton: {
    //是否显示上传按钮
    type: Boolean,
    default: true
  },
  showBorder: {
    //是否显示边框
    type: Boolean,
    default: true
  },
  showDrag: {
    //是否显示拖拽过程样式
    type: Boolean,
    default: true
  },
  btnBorder: {
    //按钮是否显示边框
    type: Boolean,
    default: false
  }
});
// 生成当前组件的唯一ID
const instanceId = `upload_com_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
const refs = reactive({});
const setRef = (e) => {
  refs[`cloud_${instanceId}`] = e;
};
const inputActiveRef = ref(null);
const token = getToken() || null;
const uploadRef = ref();
const data = reactive({
  headers: {
    authorization: `Bearer ${token}`
  },
  iconStyle: {
    width: '60px',
    height: '60px'
  }
});
// 文件类型判断
const fileType = (getFileItem, type) => {
  return getFileType(getFileItem?.name || '', type);
};
const setLink = (fileItem) => {
  return grayList?.['FilePreview:preview'] || (!fileType(fileItem, 'img') && !fileType(fileItem, 'video') && !fileType(fileItem, 'pdf')) ? setUrl(fileItem, 0) : 'javascript:void(0)';
};
const setTarget = (fileItem) => {
  return grayList?.['FilePreview:preview'] || (!fileType(fileItem, 'img') && !fileType(fileItem, 'video') && !fileType(fileItem, 'pdf')) ? '_blank' : '_self';
};
// 初始化文件列表，若 props.defaultFileList 是数组则深拷贝，否则初始化为空数组
const getFileList = ref(cloneDeep(Array.isArray(props.defaultFileList) ? props.defaultFileList : []));
const setFileList = computed(() => {
  const validList = getFileList.value?.filter((item) => item != null) || [];

  return validList;
});
const getAccept = ref('');
const getTips = ref('');
const limit = ref(0);
const fieldExt = ref({});

const getFieldExt = () => {
  if (tools.isJSON(props.fieldExt)) {
    return JSON.parse(props.fieldExt);
  }
  return props?.fieldExt || {};
};

//获取配置信息

const getSetting = () => {
  const fieldExt = getFieldExt();

  const accept = fieldExt.accept;

  limit.value = fieldExt?.limit ?? 0;

  const newAccept = Array.isArray(accept) ? accept.filter((item) => item != 0) : [];
  if (!newAccept?.length) getAccept.value = '';
  if (newAccept?.length) {
    //拼接上‘image/png, image/jpeg’
    const setAccept = newAccept?.map((item) => {
      return `.${item}`;
    });
    getAccept.value = setAccept.join(',');
  }
  const tipString = getAccept.value ? '支持上传' + `${getAccept.value}` + '格式的文件' : '文件类型无限制';
  const tips = `${tipString}` + ',' + '最多上传' + `${limit.value}` + '个文件';
  getTips.value = fieldExt?.fileType == '2' && fieldExt?.uploadType == '2' ? '本字段只支持移动端拍照上传' : tips;
};
// 处理粘贴数据的核心方法
const processPasteData = async (e) => {
  const clipboardData = e.clipboardData || window.clipboardData;
  if (!clipboardData) {
    Message.warning('浏览器不支持剪贴板操作');
    return;
  }

  const items = clipboardData.items;
  if (!items || items.length === 0) {
    return;
  }
  const pastedFiles = [];
  // 遍历剪贴板项目，查找文件
  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    if (item.kind === 'file') {
      const file = item.getAsFile();
      if (file) {
        pastedFiles.push(file);
      }
    }
  }
  // 2. 无有效文件时
  if (pastedFiles?.length === 0) {
    preventDefault(e);
    return;
  }
  // 3. 批量处理有效文件（异步操作需用await，确保顺序执行）
  for (const file of pastedFiles) {
    // 逐个处理文件（利用原有的beforeUpload校验，避免重复逻辑）
    const isValid = await beforeUpload(file); // 关键：await确保校验完成再处理下一个
    if (isValid) {
      handleUploadFile(file); // 关键：await确保上传流程完成再处理下一个
    }
  }
  // 5. 阻止默认行为（避免粘贴内容被解析为文本等）
  preventDefault(e);
};

// 处理上传的文件
const handleUploadFile = async (file) => {
  //   // 创建文件对象，符合组件要求的格式
  const fileItem = createFileItem(file);
  // 4. 添加到文件列表
  getFileList.value.push(fileItem);
  uploadChange(getFileList.value); // 触发列表更新
  // 5. 触发上传
  await customUpload({ fileItem });
};
// 激活状态
const isActive = computed(() => {
  return uploadStore.globalAttachmentInstances.some((item) => item.id === instanceId && item.active);
});
// 是否显示覆盖层（全局拖拽中才显示）
const showCover = computed(() => uploadStore.globalDragActive);
// 当前组件是否被拖拽触碰（用于区分蓝色/灰色边框）
const isHovered = computed(() => uploadStore.hoverInstanceId === instanceId);
// 禁止操作
const setStopHandle = (e) => {
  if (props?.disabled) return false; // 禁用状态下不触发激活
  if (e.dataTransfer.effectAllowed == 'move') return false; // 排序中不触发激活
  return true;
};
// 处理全局事件
const handleGlobalClick = async (e) => {
  await nextTick(); // 等待DOM更新

  const targetInstance = uploadStore.globalAttachmentInstances.find((instance) => {
    return instance.id !== instanceId && instance.ref?.value?.contains(e.target);
  });

  const isClickInsideSelf = refs?.[`cloud_${instanceId}`]?.contains(e.target);
  //  点击目标不是附件 → 取消所有组件的激活状态
  if (!targetInstance || !isClickInsideSelf) {
    uploadStore.clearActive();
  }
};
// 处理粘贴事件（组件内区域）
const handlePaste = (e) => {
  if (props?.disabled) return; // 禁用状态下不触发激活
  if (!isActive.value) return; //没有激活不能粘贴
  if (!uploadClick()) return; //上传前校验
  processPasteData(e);
};
// 点击事件
const handleClick = (e) => {
  if (props?.disabled) return; // 禁用状态下不触发激活
  e.stopPropagation(); // 阻止事件冒泡（避免触发父组件的全局点击取消逻辑）
  uploadStore.setActive(instanceId);
};

// 拖拽经过事件
const handleDragOver = (e) => {
  if (!setStopHandle(e)) return false;

  preventDefault(e);
  uploadStore.setGlobalDragActive(true);
};

// 组件拖拽进入：标记当前组件为“被hover”
const handleDragEnter = (e) => {
  if (!setStopHandle(e)) return false;

  preventDefault(e); // 阻止默认行为，避免影响drop
  if (uploadStore.globalDragActive) {
    // 仅在全局拖拽中生效
    uploadStore.setHoverInstanceId(instanceId);
  }
};

// 组件拖拽离开：清空当前组件的“hover”状态
const handleDragLeave = (e) => {
  if (!setStopHandle(e)) return false;

  preventDefault(e);
  // 当拖拽点真的离开组件时
  if (!refs?.[`cloud_${instanceId}`]?.contains(e.relatedTarget)) {
    uploadStore.setHoverInstanceId(null);
  }
};
// const drapData = ref(null);
// 拖拽放下事件
const handleDrop = async (e) => {
  if (!setStopHandle(e)) return false;
  preventDefault(e); // 必须：阻止浏览器默认行为（避免打开文件）
  uploadStore.clearDragState(); // 清空拖拽状态
  if (!uploadClick()) return false;

  // 1. 获取拖拽的文件列表（核心：从 DataTransfer 中提取文件）
  const clipboardData = e.dataTransfer || window.clipboardData;
  const draggedFiles = getDraggedFiles(clipboardData);
  //   console.log("拖拽放下事件", draggedFiles);
  if (!draggedFiles) {
    return;
  }
  // 4. 复用现有逻辑：校验并上传图片（与粘贴、选择文件逻辑一致）
  for (const file of draggedFiles) {
    const isValid = await beforeUpload(file); // 校验文件大小、类型
    if (isValid) {
      handleUploadFile(file); // 上传文件（创建文件项、触发上传请求）
    }
  }
};
// 全局禁止默认行为
const preventDefault = (e) => {
  e.stopPropagation();
  e.preventDefault();
};
// 全局拖拽进入页面
const handleGlobalDragEnter = (e) => {
  if (!setStopHandle(e)) return false;
  preventDefault(e);

  uploadStore.setGlobalDragActive(true);
};
// 全局拖拽离开页面：判断是否真的离开（避免误判组件内部拖拽）
const handleGlobalDragLeave = (e) => {
  preventDefault(e);
  // 当拖拽点离开整个文档时，才标记“全局拖拽结束”
  if (e.clientX <= 0 || e.clientY <= 0 || e.clientX >= window.innerWidth || e.clientY >= window.innerHeight) {
    uploadStore.clearDragState(); // 同时清空hover状态
  }
};

// 全局拖拽结束（放下/取消）：清空所有拖拽状态
const handleGlobalDragEnd = (e) => {
  preventDefault(e);
  uploadStore.clearDragState();
};
//排序
const onGroupMove = (e) => {
  uploadStore.clearDragState();
  const targetClass = e.to.getAttribute('class');
  if (!targetClass?.includes(`cloud-draggable-content-${instanceId}`)) {
    return false;
  }
};
// 拖拽结束事件

const onGroupEnd = (e) => {
  // 1. 从事件参数中解构 oldIndex（原位置）和 newIndex（新位置）
  const { oldIndex, newIndex } = e;

  // 2. 校验索引有效性（避免异常情况，如拖拽超出列表范围）
  if (
    oldIndex === newIndex || // 未发生位置变化（拖拽后回到原位置）
    oldIndex < 0 ||
    newIndex < 0 || // 索引为负数（无效）
    oldIndex >= getFileList.value.length || // 原索引超出数组长度
    newIndex >= getFileList.value.length // 新索引超出数组长度
  ) {
    return false; // 无需处理，直接返回
  }

  const [movedItem] = getFileList.value.splice(oldIndex, 1);
  // 步骤2：将删除的元素插入到新索引（newIndex）的位置
  getFileList.value.splice(newIndex, 0, movedItem);

  handleCb();
};
// 新增：全局事件统一阻止默认行为
const addEventListener = () => {
  document.addEventListener('click', handleGlobalClick);
  document.addEventListener('dragenter', handleGlobalDragEnter);
  document.addEventListener('dragleave', handleGlobalDragLeave);
  document.addEventListener('drop', handleGlobalDragEnd);
  document.addEventListener('dragover', preventDefault);
  document.addEventListener('dragend', handleGlobalDragEnd);
};
// 新增：移除全局事件统一阻止默认行为
const removeEventListener = () => {
  //清空实例id
  uploadStore.clearInstanceId();
  uploadStore.clearDragState();
  refs[`cloud_${instanceId}`] = null;
  document.removeEventListener('click', handleGlobalClick);
  document.removeEventListener('dragenter', handleGlobalDragEnter);
  document.removeEventListener('dragleave', handleGlobalDragLeave);
  document.removeEventListener('drop', handleGlobalDragEnd);
  document.removeEventListener('dragover', preventDefault);
  document.removeEventListener('dragend', handleGlobalDragEnd);
};
onMounted(() => {
  // 组件挂载时
  fieldExt.value = getFieldExt();
  getSetting();
  // 组件挂载时，更新实例id为当前组件实例引用
  uploadStore.updateInstanceId({ id: instanceId, ref: refs?.[`cloud_${instanceId}`], active: props?.showBorder ? false : !props.disabled });

  // 新增：全局事件统一阻止默认行为
  addEventListener();
  nextTick(() => {
    if (!props?.showBorder && !props?.disabled && refs?.[`cloud_${instanceId}`]) {
      inputActiveRef.value?.focus();
    }
  });
});
onUnmounted(() => {
  // 移除全局监听
  removeEventListener();
});

const handleCb = () => {
  emits('cb', [...(Array.isArray(getFileList.value) ? getFileList.value : [])]);
};

const customUpload = async (option) => {
  if (!grayList?.['FileStorage:minioOss']) {
    //oss上传
    await getOssConfig();
  }
  const { fileItem } = option;
  let _findIndex = -1;

  // 找到当前文件在列表中的索引
  if (setFileList.value?.length > 0 && fileItem) {
    _findIndex = setFileList.value?.findIndex((el) => el?.uid === fileItem?.uid);
  }
  if (_findIndex > -1) {
    // 标记文件状态为上传中
    getFileList.value[_findIndex]['status'] = 'uploading';
  }

  try {
    // 调用自定义请求方法，传入进度回调
    const response = await customRequest(fileItem);
    let signedUrl = null;
    if (!grayList?.['FileStorage:minioOss'] && filePath.value[fileItem?.uid]?.url) {
      signedUrl = await getSignedUrl(filePath.value[fileItem.uid].url); //oss上传签名url
    }

    const getFilePath = grayList?.['FileStorage:minioOss'] ? response?.result?.[0]?.url : setOssConfig.value.baseUrl + filePath.value[fileItem.uid].url;

    if (!response?.error || response?.res?.status === 200) {
      if (_findIndex > -1) {
        // 上传成功：更新状态为完成
        const file = getFileList.value[_findIndex];
        file['status'] = 'done';
        file['url'] = getFilePath;
        file['signedUrl'] = signedUrl;
        file['filePath'] = filePath.value[fileItem.uid]?.url || null;
        file.response = {
          code: 0,
          data: [
            {
              url: getFilePath,
              name: fileItem.name
            }
          ],
          signedUrl: signedUrl
        };
      }
      handleCb();
    }
    if (fileInput.value?.value) {
      fileInput.value.value = '';
    }
  } catch (error) {
    console.log('error', error);
    Message.error('上传失败');
    if (_findIndex > -1 && getFileList.value && getFileList.value?.[_findIndex]) {
      // 确保文件对象存在再进行操作
      const file = getFileList.value[_findIndex];
      file['status'] = 'error';

      file.response = '';
    }
    if (fileInput.value?.value) {
      fileInput.value.value = '';
    }
    handleCb();
  }
};

// 点击上传按钮
const uploadClick = () => {
  const fieldExt = getFieldExt();

  const limit = fieldExt?.limit ?? 0;

  if (fieldExt?.fileType == '2' && fieldExt?.uploadType == '2') {
    //拍照上传
    Message.error('本字段只支持移动端拍照上传');
    return false;
  }
  if (limit > 0 && getFileList.value?.length >= limit) {
    //超出
    Message.error('最多上传' + `${limit}` + '个文件');
    return false;
  }
  return true;
};
//超出限制数量后校验
const exceedLimit = (fileList, files) => {
  console.log('fileList', fileList);

  if (Number(files.length + setFileList.value.length) > limit.value) {
    Message.error('最多上传' + `${limit.value}` + '个文件');
    return false;
  }
};
//选择文件
const selectFiles = () => {
  if (props?.disabled) return; // 禁用状态下不触发激活
  if (!uploadClick()) return;
  fileInput.value?.click();
};
//选择文件
const onFileChange = async (event) => {
  //   console.log("选择文件", event.target.files);
  const files = event.target.files;

  if (!files || files.length === 0) {
    return;
  }
  const pastedFiles = [];
  // 查找文件
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    if (file) {
      pastedFiles.push(file);
    }
  }
  // 2. 无有效文件时
  if (pastedFiles?.length === 0) return;
  // 3. 批量处理有效文件（异步操作需用await，确保顺序执行）
  for (const file of pastedFiles) {
    // 逐个处理文件（利用原有的beforeUpload校验，避免重复逻辑）
    const isValid = await beforeUpload(file); // 关键：await确保校验完成再处理下一个
    if (isValid) {
      handleUploadFile(file); // 关键：await确保上传流程完成再处理下一个
    }
  }
};

// 上传前效验文件大小
const beforeUpload = async (file) => {
  //   console.log("file", file);

  const name = file.name;
  const namelist = [];
  setFileList.value?.map((el) => namelist.push(el.name));

  const fileSuffix = getFileSuffix(name); // 文件类型

  const typeList = fieldExt.value.accept;
  if (limit.value > 0 && namelist?.length >= limit.value) {
    Message.error('单次上传最多支持' + `${limit.value}` + '个文件');
    return false;
  }
  if (getAccept.value && typeList?.indexOf(fileSuffix) == -1) {
    Message.error('上传失败,请上传支持的文件类型');
    return false;
  }
  if (file.size / 1024 / 1024 >= 300) {
    Message.error('上传失败,文件大小不能超过300M');
    return false;
  }

  return true;
};
const getDisabled = computed(() => {
  // 基础禁用状态由props决定
  let disabled = props.disabled;

  const fieldExt = getFieldExt();
  const limit = fieldExt?.limit ?? 0;

  // 拍照类型特殊处理
  if (fieldExt?.fileType === '2' && fieldExt?.uploadType === '2') {
    disabled = true;
  }

  // 超出文件数量限制
  if (limit > 0 && getFileList.value?.length >= limit) {
    disabled = true;
  }

  return disabled;
});

const uploadChange = (fileList) => {
  getFileList.value = Array.isArray(fileList) ? fileList : [];
};
const beforeRemove = (item) => {
  const index = getFileList.value.findIndex((file) => file.url === item.url);
  if (index > -1) {
    getFileList.value.splice(index, 1);
    handleCb();
  }
};
//下载
const handleDownload = (item) => {
  const getFilePath = setUrl(item, 1);
  downloadFile(getFilePath, item.name);
};
// 重新上传
const retryUpload = (item) => {
  // 1. 找到当前文件在文件列表中的索引
  const fileIndex = getFileList.value.findIndex((file) => file.uid === item.uid);
  if (fileIndex === -1) return; // 未找到文件，直接返回

  // 2. 重置文件状态为“上传中”，进度清零
  getFileList.value[fileIndex] = {
    ...item,
    status: 'uploading' // 初始状态
  };

  // 3. 构造 customUpload 需要的参数（与原始上传逻辑保持一致）
  const uploadOption = {
    fileItem: getFileList.value[fileIndex], // 目标文件对象
    onSuccess: () => {}, // 可自定义成功回调（可选）
    onError: () => {} // 可自定义失败回调（可选）
  };

  // 4. 调用 customUpload 重新触发上传
  customUpload(uploadOption);
};
const visible = ref(false);
const getFileItem = ref(null);
const getFileIndex = ref(0);
//打开弹窗预览
const openPreview = (fileItem, index) => {
  // 众行互动不展示预览
  if (grayList?.['FilePreview:preview']) return;
  if (!checkInvalidUrl(fileItem)) return;
  if (!fileType(fileItem, 'img') && !fileType(fileItem, 'video') && !fileType(fileItem, 'pdf')) return;
  visible.value = true;
  getFileItem.value = fileItem;
  getFileIndex.value = index;
  nextTick(() => {
    previewModalRef.value?.openPreviewModal({
      index: getFileIndex.value
    });
  });
};
</script>
<style scoped lang="less">
@import './fh-attachment-upload.less';
</style>
<style>
.cloud-modal .arco-modal-body {
  height: 400px;
  overflow: hidden;
  overflow-y: scroll;
}
</style>
